import { GridColDef } from "@mui/x-data-grid-pro";

/**
 * Determines whether a filter value is considered valid for a given column type.
 * Filters with invalid values are excluded from the server-side query.
 */
export const isValidValue = (value: unknown, type: GridColDef["type"]): boolean => {
  switch (type) {
    case "boolean":
      return value === true || value === false;
    case "number":
      return typeof value === "number" && !isNaN(value);
    case "string":
      return typeof value === "string" && value.trim() !== "";
    case "date":
    case "dateTime":
      return value instanceof Date && !isNaN(value.getTime());
    default:
      return value !== undefined && value !== null;
  }
};
